









































































































































import S3Image from '@/components/S3Image.vue';


import {Component, Vue, Prop} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';
import PostCommentField from '@/modules/admin/comments/_components/PostCommentField.vue';
import InfiniteLoading from 'vue-infinite-loading';
import PostLikeField from '@/modules/admin/likes/_components/PostLikeField.vue';
import S3Video from '@/components/S3Video.vue';
import AnimalSubscriptionsTable from '@/modules/admin/animals/_components/AnimalSubscriptionsTable.vue';

@Component({
  components: {
    AnimalSubscriptionsTable,
    S3Video,
    PostCommentField,
    S3Image,
    PostLikeField,
    InfiniteLoading,
  },
})
export default class List extends Vue {
  private complete: boolean = false;
  private loading: boolean = true;
  private selectedPost: any = null;
  private isModalVisible: boolean = false;
  private active: number | null = null;

  @Prop({type: String, default: ''}) private id!: string;

  @Action('admin/animals/readOne') private readAnimal!: any;
  @Action('admin/subscriptions/read') private createSubscription!: any;
  @Getter('admin/subscriptions/all') private all!: any;
  @Getter('admin/animals/one') private animal!: any;
  @Getter('admin/animals/isAllLoaded') private isAllLoaded!: boolean;

  private created() {
    this.loading = true;
    this.readAnimal({id: this.id})
      .then(() => {
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });
  }

  private infiniteHandler($state) {
    if (this.isAllLoaded) {
      $state.complete();
      return;
    }
    if (this.loading) {
      return;
    }
    this.readAnimal({id: this.id}).then(() => this.isAllLoaded ? $state.complete() : $state.loaded());
  }

  private setSelectedPost(post) {
    this.selectedPost = post;
    this.showModal();
  }

  private showModal() {
    this.isModalVisible = true;
    document.body.classList.add('no-scroll');
  }

  private hideModal() {
    this.isModalVisible = false;
    document.body.classList.remove('no-scroll');
  }

  private getPostText(description: string) {
    return description ? description.replace(/\n/gm, '</br>') : '';
  }

  private updateComment() {
    this.readAnimal({id: this.id}).then(() => {
      this.selectedPost = this.animal.posts.find((el) => el.id === this.selectedPost.id);
    });
  }

  private toggleLike() {
    this.selectedPost = {
      ...this.selectedPost,
      liked: !this.selectedPost.liked,
      likes: this.selectedPost.liked ? this.selectedPost.likes - 1 : this.selectedPost.likes + 1,
    };
  }
}
